module.exports = __webpack_public_path__ + "media/images/htt_splash_screen-464f9345cfde67992771236587e8d0c4.png";